import { render } from "./mso.vue?vue&type=template&id=b8bf048a"
import script from "./mso.vue?vue&type=script&lang=js"
export * from "./mso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__